import { isNorthstarBrand } from '@pb/utils'

const ANCHOR_ROUTES = {
  HOME: '/',
}

const LINK_ROUTES = {
  HUB: '/',
}

const STORE_TAB = {
  id: 'store',
  text: !isNorthstarBrand
    ? 'account.digitalreceipts.storereceipts'
    : 'account.digitalreceipts.storereceipts.ns',
}
const ONLINE_TAB = {
  id: 'online',
  text: !isNorthstarBrand
    ? 'account.digitalreceipts.onlineorders'
    : 'account.digitalreceipts.onlineorders.ns',
}

const ORDER_STATUSES = {
  CANCELLED: 'cancelled',
}

const OMNICREDIT_CODES = {
  PAYLATER: 'pay_later',
  PAYNOW: 'pay_now',
}

export { ANCHOR_ROUTES, LINK_ROUTES, STORE_TAB, ONLINE_TAB, ORDER_STATUSES, OMNICREDIT_CODES }
